import React, {useState} from "react";
import { Link } from "react-router-dom";
import { Row, Col, Form, Input, Button, message, Alert } from "antd";
import axios from "axios";

import LeftContent from "../leftContent";

export default function RecoverPassword() {
  const [errorMsg, setErrorMsg] = useState(false);

  const handleResetPassword = async (values) => {
    const { email } = values;
    const postData = {
      email,
    };

    try {
      // Validate email domain is orevan.org
      if (!email.endsWith("@orevan.org")) {
        message.error("Please use an email with orevan.org domain");
        return;
      }

      // Make post request to password reset endpoint
      const response = await axios.post(
        "https://internal.orevan-prox.com/password_reset/",
        postData
      );

      // Handle success response
      if (response.status === 200) {
        setErrorMsg(true)
        message.success("Password reset instructions sent");
      } else {
        message.error("Failed to send password reset instructions");
      }
    } catch (error) {
      console.error("Password reset error:", error);
      message.error("Failed to send password reset instructions");
    }
  };

  return (
    <Row gutter={[32, 0]} className="hp-authentication-page">
      <LeftContent />

      <Col md={12}>
        <Row className="hp-h-100" align="middle" justify="center">
          <Col
            xxl={11}
            xl={15}
            lg={20}
            md={20}
            sm={24}
            className="hp-px-sm-8 hp-pt-24 hp-pb-48"
          >
            <h1 className="hp-mb-sm-0">Recover Password</h1>
            <p className="hp-mt-sm-0 hp-mt-8 hp-text-color-black-60">
              We’ll e-mail you instructions on how to reset your password.
            </p>

            { errorMsg ? 
                  <Alert message="Password reset instructions have been sent to your email!" type="success" /> 
									:
									undefined
						}
            <Form
              layout="vertical"
              name="basic"
              className="hp-mt-sm-16 hp-mt-32"
              onFinish={handleResetPassword}
            >
              <Form.Item
                label="E-mail:"
                name="email"
                rules={[
                  { required: true, message: "Please enter your email" },
                  { type: "email", message: "Please enter a valid email" },
                ]}
              >
                <Input placeholder="you@orevan.org" />
              </Form.Item>

              <Form.Item className="hp-mt-16 hp-mb-8">
                <Button block type="primary" htmlType="submit">
                  Reset Password
                </Button>
              </Form.Item>
            </Form>

            <div className="hp-form-info">
              <span className="hp-text-color-black-80 hp-text-color-dark-40 hp-caption hp-mr-4">
                Go back to
              </span>

              <Link
                to="/"
                className="hp-text-color-primary-1 hp-text-color-dark-primary-2 hp-caption"
              >
                Login
              </Link>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
